// src/Pages/Writing/ChereAmie_1.jsx
import React, { useState } from "react";
import Box from "@mui/material/Box";
import { ThemeProvider, createTheme, Typography, Tabs, Tab } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link as RouterLink } from "react-router-dom";
import Footer from "../Footer";
import cherePic from "./chereamie_1.jpg";
import cherePic2 from "./chereamie_2.jpg";
import cherePic3 from "./chereamie_3.jpg";

export default function ChereAmie_1() {
  const [tabIndex, setTabIndex] = useState(0);

  const theme = createTheme({
    typography: {
      fontFamily: "Helvetica, Arial, sans-serif",
      h1: {
        fontSize: "3rem",
        fontWeight: 200,
        lineHeight: 1.1,
        wordBreak: "break-word",
        overflowWrap: "anywhere",
      },
      body1: {
        fontSize: "1.25rem",
        fontWeight: 200,
        "@media (max-width:600px)": { fontSize: "1.25rem", fontWeight: 300 },
      },
    },
  });

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isDesktop = useMediaQuery("(min-width:600px)");

  const container80 = { width: "80vw", maxWidth: 1200, boxSizing: "border-box" };
  const imageContainerStyle = {
    width: isDesktop ? "35vw" : "80vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    marginTop: "2vw",
  };
  const imageStyle = { width: "100%", height: "auto", maxWidth: "100%" };
  const dualImageContainerStyle = {
    display: "flex",
    flexDirection: isDesktop ? "row" : "column",
    justifyContent: "center",
    alignItems: "center",
    gap: isDesktop ? "1rem" : "2vh",
    width: isMobile ? "80vw" : "800px",
    margin: "2vw auto 0",
  };
  const dualImageStyle = {
    width: isDesktop ? "50%" : "100%",
    height: "auto",
    maxWidth: "100%",
  };
  const writingBoxStyle = {
    width: isMobile ? "100vw" : "800px",
    maxWidth: isMobile ? "100vw" : "800px",
    boxSizing: "border-box",
    px: "2rem",
    py: "3rem",
    borderTop: "1px solid black",
    borderBottom: "1px solid black",
    mb: "6vh",
    backgroundColor: "white",
    mx: "auto",
  };
  const writingTextStyle = {
    fontFamily: `Georgia, "Times New Roman", Times, serif`,
    fontSize: "1.15rem",
    fontWeight: 400,
    lineHeight: 1.7,
    textAlign: "justify",
    whiteSpace: "pre-line",
    "& b, & strong": { fontWeight: 700 },
    "& i, & em": { fontStyle: "italic" },
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {/* Main content */}
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          flex={1}
          marginTop="5vh"
        >
          {/* Title */}
          <Box sx={{ width: "80vw", maxWidth: 1200, mb: "5vh", textAlign: "center" }}>
            <RouterLink
              to="/writing"
              style={{
                color: "inherit",
                textDecoration: "none",
              }}
            >
              <Typography variant="h1">
                // Chère Amie <span style={{ fontSize: "0.6em" }}>(#1)</span>
              </Typography>
            </RouterLink>
          </Box>

          {/* Intro text */}
          <Box sx={{ ...container80, mb: "3vh" }}>
            <Typography
              variant="body1"
              sx={{
                lineHeight: 1.5,
                whiteSpace: "pre-line",
                maxWidth: "68ch",
                mx: "auto",
                textAlign: "left",
              }}
            >
              On September 13th 2025 the independent Zürich-based{" "}
              <a
                href="https://www.instagram.com/chere_amie_magazine"
                target="_blank"
                rel="noreferrer"
              >
                Chère Amie
              </a>{" "}
              magazine launched their first edition, and inside, between a finely curated
              selection of works, is my first piece of published writing:
              <br />
              <br />
              <b>"una pagina"</b>
              <br />
              <br />
              Here you will find the Italian original and the respective English and French
              translations.
            </Typography>
          </Box>

          {/* Images */}
          <Box style={dualImageContainerStyle} mb="2vh">
            <img src={cherePic} alt="Chère Amie – una pagina 1" style={dualImageStyle} />
            <img src={cherePic2} alt="Chère Amie – una pagina 2" style={dualImageStyle} />
          </Box>

          <Typography
            variant="captionCustom"
            sx={{
              color: "gray",
              textAlign: "center",
              display: "block",
              mx: "auto",
              marginTop: "2vh",
              width: isDesktop ? "800px" : "80%",
            }}
          >
            ^ © 2025&nbsp;// Emily Latino // Chère Amie ^
          </Typography>

          {/* Tabs */}
          <Box
            sx={{
              width: isMobile ? "100vw" : "800px",
              mx: "auto",
              mb: "2vh",
              mt: "2vh",
              boxSizing: "border-box",
            }}
          >
            <Tabs
              value={tabIndex}
              onChange={(e, v) => setTabIndex(v)}
              variant={isMobile ? "fullWidth" : "standard"}
              centered={!isMobile}
              textColor="inherit"
              indicatorColor="primary"
              sx={{
                maxWidth: "100%",
                "& .MuiTab-root": {
                  fontWeight: 400,
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                },
              }}
            >
              <Tab label="Italiano" sx={{ minWidth: 0, flex: 1 }} />
              <Tab label="English" sx={{ minWidth: 0, flex: 1 }} />
              <Tab label="Français" sx={{ minWidth: 0, flex: 1 }} />
            </Tabs>
          </Box>

          {/* ITALIANO */}
          {tabIndex === 0 && (
            <Box sx={writingBoxStyle}>
              <Typography variant="body1" component="div" sx={writingTextStyle}>
                {/* ——— keep your Italian text here exactly as you have it ——— */}
                <b>una pagina</b>
                <br /><br />
                Ci troviamo su una diga, un muro colossale che separa acqua e vuoto, a guardare il 
                plenilunio. Le nuvole non permettono alla luce di passare, impedendomi di 
                stimarne accuratamente l’altezza: in ogni caso direi duecento metri, o giù di lì. C’è  
                una candela la cui fiamma è ferma in posizione orizzontale, parallela rispetto al 
                cemento del colosso; ci sono delle carezze, dei pantaloni sbottonati, si avvicinano 
                delle voci. Cambio di scena: siamo su una macchina da corsa, sfrecciamo 
                zigzagando tra le montagne a grande velocità. So per certo che il baricentro basso 
                del veicolo, dotato di una potenza di centonovanta cavalli per milleduecento chili di 
                peso, ci permette di non cappottarci. Ma dura poco, non vogliamo mica incagliarci 
                da qualche parte. Stiamo di nuovo guardando la luna, questa volta con un binocolo. 
                È maculata. Un test di Rorschach? Nei crateri ci vediamo uno scheletro, più 
                simpatico sicuramente di quello che mi ha spaventato sbucando da dietro un 
                armadio qualche settimana fa. Questa luna, come stesse flirtando, ci osserva 
                tacitamente. Siamo solo noi tre, più i grilli che urlano al nulla. La luce bianca adesso 
                proviene da un enorme crocifisso, una finestrata in fondo alla chiesa, e l’ambiente 
                sonoro è passato dai rumori della natura al fine Ottocento. Sento Franck, forse 
                Debussy. Ci sono degli applausi, e tutto ad un tratto siamo al fiume. Dei lavori in 
                corso indicano che questo piccolo angolo di paradiso verrà presto invaso dai 
                turisti, ovvero la fine del suo ciclo vitale, ma in ogni caso l’acqua è troppo fredda e 
                non ci voglio restare più di qualche secondo. Lo shock dell’acqua gelida mi sveglia, 
                sono nel mio vecchio letto sormontato da un grande poster di <i>Pulp Fiction</i>. Sono 
                quindi a casa di mia madre, e il sole mattutino filtra a strisce attraverso le persiane 
                delineando un corpo nudo da parte al mio. Automaticamente i miei polpastrelli 
                percorrono i fianchi, la cassa toracica, i seni, per poi fermarsi al collo: è caldo. Non 
                ho voglia di starmene a letto, mi metto dei pantaloni e mi faccio un caffè. Accesa la 
                sigaretta e inforcati gli occhiali da sole noto, dal divanetto della terrazza, che nel 
                mio giardino è sbucata una tenda. Una tenda che brulica di persone equipaggiate 
                con vari strumenti. Ma stanno girando un film? Chiedo. Stanno girando un film, un 
                cortometraggio. Offro del caffè, ma hanno la loro scorta, quindi mi limito ad 
                osservarli nel loro lavoro. Mi arriva una telefonata: è una modella, è nel mio 
                giardino anche lei. Scendo allora, prendendo all’uscio un pacco di fazzoletti perché 
                questa qui soffre di allergia. Ma si può? Dico io, avere attorno tutta ‘sta gente che 
                mi rovina la stagione più bella (diciamocelo, chi non predilige la primavera tra tutte 
                e cinque le stagioni ha sicuramente un qualche problema) lamentandosi 
                costantemente dei pollini e prendendo antistaminici come se fossero caramelle, 
                riempendo i cestini con i loro fazzolettini pieni di muco. Ora che ci penso l’anno 
                scorso sono diventato allergico pure io, non so a cosa, ma soffro di allergia, e gli 
                antistaminici ce li ho sul comodino. <i>Sniff.</i>
                <br />
                Sono usciti dei begli scatti, però è ora di tornarmene a letto. Il sole, alto nel cielo, 
                sta riscaldando la mia piccola bolla di vita e sento questo calore entrare nei miei 
                polmoni, lo sento ustionare i miei bronchi da fumatore incallito come se fossi in 
                una sauna, e non riesco più a respirare. 
                <br />
                Mi sveglio. Siamo su un treno. De Andrè? Sì, proprio lui, sta suonando la chitarra 
                nello scompartimento da parte al mio. Canta, ma non è solo: tutto il vagone sta 
                cantando. Effettivamente, pensandoci su, è un po’ strano che questo vagone sia 
                pieno di gente che canta, ride, e gioca a carte. Sono sicuro di essere su un treno? Il 
                coro continua, la chitarra viene passata. Musica cilena, Bach, altro cantautorato 
                italiano. Sta girando una ciotola piena di pesche, mature e polpose, le mie dita 
                appiccicano un po’ ma non me la sento di leccarle. Ci fermiamo, delle persone 
                scendono e delle persone salgono, la musica continua. Passa il controllore, 
                stranamente non dice niente a riguardo. A moltissimi controllori piace giocare a 
                fare i poliziotti, ne sono certo, ho viaggiato molto. Ogni tanto mi capita di salutare 
                la persona che lavora nel vagone ristorante: a furia di rivedersi si crea questa 
                dinamica del saluto, una di quelle relazioni strane dove non sai se salutare o meno. 
                Non vedo l’ora di scendere dal treno e di fare l’amore. <i>Sniff.</i>
              </Typography>
            </Box>
          )}

          {/* ENGLISH */}
          {tabIndex === 1 && (
            <Box sx={writingBoxStyle}>
              <Typography variant="body1" component="div" sx={writingTextStyle}>
                {/* ——— keep your English text here exactly as you have it ——— */}
                <b>a page</b>
                <br /><br />
                We are standing on a dam, a colossal wall that separates water from emptiness, watching the full 
                moon. The clouds don’t let the light through, preventing me from accurately estimating the height: 
                in any case, I’d say two hundred meters, give or take. There’s a candle whose flame is fixed in a 
                horizontal position, parallel to the concrete of the colossus; there are caresses, unbuttoned pants, 
                voices approaching. Scene change: we’re in a race car, speeding and weaving through the 
                mountains at high velocity. I know for certain that the car’s low center of gravity, with a power of 
                190 horsepower and weighing twelve hundred kilos, keeps us from flipping over. But it doesn’t last 
                long — we don’t want to get stuck somewhere. We’re watching the moon again, this time through 
                binoculars. It’s speckled. A Rorschach test? In the craters we see a skeleton, definitely more likable 
                than the one that scared me by jumping out from behind a wardrobe a few weeks ago. This moon, 
                as if flirting, silently observes us. Just the three of us, plus the crickets screaming into the void. The 
                white light now comes from a huge crucifix, a stained-glass window at the back of the church, and 
                the soundscape has shifted from nature’s noises to the late 19th century. I hear Franck, maybe 
                Debussy. There’s applause, and suddenly we’re at the river. Some construction work signals that 
                this little corner of paradise will soon be overrun by tourists — the end of its life cycle, really — but 
                in any case, the water is too cold and I don’t want to stay in longer than a few seconds. The shock of 
                the icy water wakes me up, I’m in my old bed beneath a large <i>Pulp Fiction</i> poster. So I’m at my 
                mother’s house, and the morning sun filters through the blinds in stripes, outlining a naked body 
                next to mine. Automatically, my fingertips trace the hips, the ribcage, the breasts, then stop at the 
                neck: it’s warm. I don’t feel like staying in bed, so I put on some pants and make myself a coffee. I 
                light a cigarette, put on my sunglasses, and from the little couch on the terrace I notice a tent has 
                popped up in my garden. A tent buzzing with people equipped with various tools. Are they shooting 
                a film? I ask. They are — a short film. I offer them some coffee, but they’ve brought their own 
                supply, so I just watch them work. I get a phone call: it’s a model, she’s in my garden too. So I go 
                downstairs, grabbing a pack of tissues at the door because she has allergies. Can you believe it? I 
                say — all these people ruining the best season (let’s face it, anyone who doesn’t prefer spring out of 
                all five seasons must have some sort of problem), constantly complaining about pollen and popping 
                antihistamines like candy, filling up bins with their snotty tissues. Now that I think about it, I 
                developed allergies myself last year. Don’t know to what, but I suffer from it, and the antihistamines 
                are on my nightstand. <i>Sniff.</i>
                <br />
                Some nice shots came out of it, but it’s time to get back to bed. The sun, high in the sky, is warming 
                my little bubble of life and I feel that warmth enter my lungs, feel it sear my smoker’s bronchi as if I 
                were in a sauna, and I can’t breathe anymore. 
                <br />
                I wake up. We’re on a train. De André? Yes, him — he’s playing the guitar in the compartment next 
                to mine. He’s singing, but he’s not alone: the whole car is singing. Thinking about it, it’s a little odd 
                that this car is full of people singing, laughing, and playing cards. Am I sure I’m on a train? The 
                singing continues, the guitar is passed around. Chilean music, Bach, more Italian singer-songwriters. 
                A bowl full of peaches is being passed around, ripe and juicy, my fingers are sticky but I don’t feel 
                like licking them. We stop, some people get off, others get on, the music keeps going. The conductor 
                passes by — strangely, he doesn’t say anything. A lot of conductors like to play cops, I’m sure of it, I’ve 
                traveled a lot. Sometimes I say hi to the person working in the dining car: after seeing each other so 
                often, you get this kind of greeting dynamic going — one of those weird relationships where you’re 
                not sure if you should say hi or not. I can’t wait to get off this train and make love. <i>Sniff.</i>
              </Typography>
            </Box>
          )}

          {/* FRANÇAIS */}
          {tabIndex === 2 && (
            <Box sx={writingBoxStyle}>
              <Typography variant="body1" component="div" sx={writingTextStyle}>
                {/* ——— keep your French text here exactly as you have it ——— */}
                <b>une page</b>
                <br /><br />
                Nous sommes sur un barrage, un mur colossal qui sépare l'eau du vide, et nous 
                regardons la lune. Elle est pleine. Les nuages ne laissent pas passer la lumière, et ça 
                m'empêche d'estimer avec précision sa hauteur : en tout cas, je dirais deux cents 
                mètres environ. Il y a une bougie dont la flamme est immobile en position 
                horizontale, parallèle au béton du colosse ; il y a des caresses, des pantalons 
                déboutonnés, des voix qui s'approchent. Changement de décor : nous sommes 
                dans une voiture de course, zigzaguant à travers les montagnes à grande vitesse. Je 
                suis sûr que le centre de gravité bas du véhicule, avec ses cent quatre-vingt-dix 
                chevaux pour mille deux cents kilos de poids, nous permet de ne pas nous 
                renverser. Mais c'est de courte durée, nous ne voulons pas nous échouer quelque 
                part. Nous regardons à nouveau la lune, cette fois avec des jumelles. Elle est 
                tachetée. Un test de Rorschach ? Dans les cratères, nous voyons un squelette, plus 
                sympathique sûrement que celui qui m'a fait peur en sortant de derrière une 
                armoire il y a quelques semaines. Cette lune, comme pour flirter, nous observe 
                tacitement. Il n'y a que nous trois, plus les grillons qui crient pour rien. La lumière 
                blanche provient maintenant d'un énorme crucifix, une fenêtre au fond de l'église, 
                et l'ambiance sonore est passée des bruits de la nature à ceux de la fin du XIXe 
                siècle. J'entends Franck, peut-être Debussy. Il y a des applaudissements, et tout 
                d'un coup, nous sommes à la rivière. Les travaux en cours indiquent que ce petit 
                coin de paradis sera bientôt envahi par les touristes, la fin de son cycle de vie, mais 
                en tout cas l'eau est trop froide et je ne veux pas y rester plus de quelques 
                secondes. Le choc de l'eau glacée me réveille, je suis dans mon vieux lit surmonté 
                d'un grand poster de <i>Pulp Fiction</i>. Ça veut dire que je suis chez ma mère, et le soleil 
                du matin filtre en traînées à travers les volets, esquissant un corps nu à coté du 
                mien. Automatiquement, le bout de mes doigts parcourt les hanches, la cage 
                thoracique, les seins, puis s'arrête sur le cou : il est chaud. N'ayant pas envie de 
                rester au lit, j'enfile un pantalon et me prépare un café. Après avoir allumé une 
                cigarette et mis mes lunettes de soleil, je constate, depuis le canapé de la terrasse, 
                qu'une tente a surgi dans mon jardin. Une tente qui grouille de gens équipés de 
                divers instruments bizarres. Mais est-ce qu'ils tournent un film ? Je demande. Oui. 
                Ils tournent un film, un courtmétrage. Je leur propose du café, mais ils ont leur 
                propre réserve, alors je me contente de les observer dans leur travail. Je reçois un 
                coup de téléphone : c'est un mannequin, apparemment elle aussi est dans mon 
                jardin. Je descends alors, en prenant un paquet de mouchoirs à la porte, car elle 
                souffre d'allergies. Ce n’est pas possible, dis-je, d’exister avec tous ces gens autour 
                de moi qui gâchent la plus belle saison (avouons-le, ceux qui ne préfèrent pas le 
                printemps entre les cinq saisons ont sûrement un problème) en se plaignant 
                constamment du pollen et en prenant des antihistaminiques comme des bonbons, 
                en remplissant les paniers avec leurs mouchoirs remplis de mucus. À bien y penser, 
                l'année dernière moi aussi je suis devenu allergique, je ne sais pas à quoi, mais j'ai 
                des allergies, et les antihistaminiques sont sur ma table de chevet. <i>Sniff.</i>
                <br />
                Quelques belles photos ont été prises, mais il est temps d'aller se coucher. Le soleil, 
                haut dans le ciel, réchauffe ma petite bulle de vie et je ressens cette chaleur entrer 
                dans mes poumons, je la sens brûler mes bronches de fumeur endurci comme si 
                j'étais dans un sauna, et je n'arrive plus à respirer. 
                <br />
                Je me réveille. Nous sommes dans un train. De André ? Oui, c'est lui, l’auteur 
                italien (n’était-il mort?), il joue de la guitare dans le compartiment en face au mien. 
                Il chante, mais il n'est pas seul : tout le wagon chante. En fait, en y réfléchissant, 
                c'est un peu étrange que ce wagon soit rempli de gens qui chantent, qui rient et qui 
                jouent aux cartes. Suis-je bien dans un train ? Les chants continuent, la guitare est 
                passée d’une personne à l’autre. Musique chilienne, Bach, des autres chansons 
                italiennes. Un bol rempli de pêches tourne, mûres et pulpeuses, mes doigts collent 
                un peu mais je n'ai pas envie de les lécher. On s'arrête, des gens descendent et 
                d'autres montent, la musique continue. Le contrôleur passe, bizarrement il ne dit 
                rien. Beaucoup de contrôleurs aiment jouer au policier, je le sais, j'ai beaucoup 
                voyagé. De temps en temps, je salue la personne qui travaille dans le wagon-
                restaurant : à force de se revoir, il se crée cette dynamique de salutation, une de ces 
                relations étranges où l'on ne sait pas si l'on doit dire bonjour ou pas. J'ai hâte de 
                descendre du train et de faire l'amour. <i>Sniff.</i>
              </Typography>
            </Box>
          )}

           {/* Closing note — 80% policy */}
          <Box sx={{ ...container80, mb: "3vh" }}>
            <Typography
              variant="body1"
              sx={{ lineHeight: 1.5, whiteSpace: "pre-line", maxWidth: "68ch", mx: "auto", textAlign: "left" }}
            >
              On a side note, I find the magazine excellent: the fruit of more than two years of passionate work,
              it’s not only rich in content but also marked by a strong visual coherence that lets the art truly shine.
              <br />Grab a copy if you can!
            </Typography>
          </Box>

        <Box style={imageContainerStyle} mb="2vh">
          <img src={cherePic3} alt="Chère Amie – una pagina 3" style={imageStyle} />
        </Box>

        </Box>

        {/* Footer */}
        <Footer />
      </Box>
    </ThemeProvider>
  );
}